import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { PhoneValidationInputDto } from '../phone-validation-input-dto';
import { UserAccountService } from '@irian-ro/util-user';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'auth-user-otp-code-form',
  templateUrl: './user-otp-code-form.component.html',
  styleUrls: ['./user-otp-code-form.component.scss'],
})
export class UserOtpCodeFormComponent {
  @Input() userUuid: string | undefined = undefined;

  @Output() phoneNumberValidated = new EventEmitter<void>();

  otp: string | undefined = undefined;

  destroyRef = inject(DestroyRef);

  constructor(
    private readonly userAccountService: UserAccountService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {}

  sendValidationSMS(uuid: string) {
    this.userAccountService.generateOtpForValidation(uuid).subscribe({
      next: () => this.handleSuccessMessage('auth.otpCodeSuccess'),
      error: () => this.handleErrorMessage('auth.phoneNumberRequiredMessage'),
    });
  }

  validateCode() {
    const phoneValidationInputDto: PhoneValidationInputDto = new PhoneValidationInputDto();
    phoneValidationInputDto.otp = this.otp;

    this.userAccountService.validateCode(this.userUuid, phoneValidationInputDto).subscribe({
      next: () => {
        this.handleSuccessMessage('auth.phoneNumberValidateSuccessMessage');
        this.phoneNumberValidated.emit();
      },
      error: () => this.handleErrorMessage('auth.invalidCode'),
    });
  }

  private handleSuccessMessage(successKey: string) {
    this.translateService
      .get([successKey])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.messageService.add({
          key: 'auth-notification',
          severity: 'success',
          summary: res[successKey],
        });
      });
  }

  private handleErrorMessage(errorKey: string) {
    this.translateService
      .get([errorKey])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.messageService.add({
          key: 'auth-notification',
          severity: 'error',
          summary: res[errorKey],
        });
      });
  }
}
